__turbopack_context__.v({
  "animate-play-pulse": "PfNfWW_animate-play-pulse",
  "pulse": "PfNfWW_pulse",
});
